<template>
    <div class="v-login-x">
        <hua-form :label-width="120" :input-align="'right'">
            <hua-field v-model="userName" label="手机号" placeholder="请输入" type="number" @input="validPsw"/>
            <hua-field v-model="password" label="密码" :placeholder="placeholder" />
        </hua-form>
        <div class="v-login-btn">
            <hua-button type="primary" block round @click="login">登 录</hua-button>
        </div>
        <div class="v-password">
            <span @click="changePassword">修改密码</span>
            <span @click="findPassword">忘记密码</span>
        </div>
    </div>
</template>

<script>
import api from '@/constants/api'
export default {
    data() {
        return {
            userName: '',
            password: '',
            placeholder: '请输入',
            timer: null
        }
    },
    methods: {
        login() {
            let params = {
                userName: this.userName,
                password: this.password,
            }
            api.auditLogin(params)
                .then((res) => {
                    let id = res.data.id
                    localStorage.setItem('u_phone', JSON.stringify(res.data.phone))
                    localStorage.setItem('u_name', JSON.stringify(res.data.name))
                    localStorage.setItem('v_personid', JSON.stringify(id))
                    localStorage.setItem('v_deptName', JSON.stringify(res.data.deptName)) // zss 234284 缓存部门信息
                    localStorage.setItem('fromH5', '1');
                    localStorage.setItem('personCode', res.data.personCode)
                    localStorage.setItem('ticket', res.data.ticket)
                    this.$router.push({ path: `/myVisitorList` })
                })
                .catch((err) => {
                    this.$toast(err.errMsg)
                })
        },
        changePassword() {
            this.$router.push({ path: '/changePassword' })
        },
        findPassword() {
            this.$router.push({ path: '/findPassword' })
        },
      validPsw() {
        this.debounce( function () {
          this.placeholder = '请输入';
          api.pswIsChanged(this.userName).then(res => {
            if (!res.data) {
              this.placeholder = '用户初始密码为人员编号';
            }
          });
        }, 1000);
      },
      //防抖, 一段时间内只执行最后一次请求
      debounce(fn, delay = 1000) {
        let that = this;
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          fn.apply(that);
        }, delay)
      }
    },
}
</script>
<style lang="less">
.v-login-x {
    .v-login-btn {
        margin: 50px 20px 20px;
    }
    .v-password {
        color: #419bfe;
        padding: 0 35px;
        display: flex;
        justify-content: space-between;
    }
}
</style>
